import { Extension as ve, combineTransactionSteps as Ne, getChangedRanges as xe, findChildrenInRange as Pe } from "@tiptap/core";
import { Slice as Se, Fragment as Ie } from "prosemirror-model";
import { Plugin as Be, PluginKey as Te } from "prosemirror-state";
import { v4 as ze } from "uuid";
function M(e) {
  return e.type === "link";
}
function je(e) {
  return typeof e != "string" && e.type === "link";
}
function x(e) {
  return typeof e != "string" && e.type === "text";
}
function U(e) {
  var t, r, n, o, s;
  return W(e) ? {
    type: "tableCell",
    content: [].concat(e.content),
    props: {
      backgroundColor: ((t = e.props) == null ? void 0 : t.backgroundColor) ?? "default",
      textColor: ((r = e.props) == null ? void 0 : r.textColor) ?? "default",
      textAlignment: ((n = e.props) == null ? void 0 : n.textAlignment) ?? "left",
      colspan: ((o = e.props) == null ? void 0 : o.colspan) ?? 1,
      rowspan: ((s = e.props) == null ? void 0 : s.rowspan) ?? 1
    }
  } : {
    type: "tableCell",
    // FIXME: content can actually be Partial, we should probably handle this as well
    content: [].concat(e),
    props: {
      backgroundColor: "default",
      textColor: "default",
      textAlignment: "left",
      colspan: 1,
      rowspan: 1
    }
  };
}
function W(e) {
  return e != null && typeof e != "string" && !Array.isArray(e) && e.type === "tableCell";
}
function z(e) {
  return W(e) && e.props !== void 0 && e.content !== void 0;
}
function I(e) {
  return z(e) ? e.props.colspan ?? 1 : 1;
}
function F(e) {
  return z(e) ? e.props.rowspan ?? 1 : 1;
}
class R extends Error {
  constructor(t) {
    super(`Unreachable case: ${t}`);
  }
}
function tn(e, t = !0) {
  const { "data-test": r, ...n } = e;
  if (Object.keys(n).length > 0 && t)
    throw new Error("Object must be empty " + JSON.stringify(e));
}
function _(e) {
  const { height: t, width: r } = fe(e), n = new Array(t).fill(!1).map(() => new Array(r).fill(null)), o = (s, i) => {
    for (let c = s; c < t; c++)
      for (let a = i; a < r; a++)
        if (!n[c][a])
          return { row: c, col: a };
    throw new Error(
      "Unable to create occupancy grid for table, no more available cells"
    );
  };
  for (let s = 0; s < e.content.rows.length; s++)
    for (let i = 0; i < e.content.rows[s].cells.length; i++) {
      const c = U(e.content.rows[s].cells[i]), a = F(c), l = I(c), { row: f, col: p } = o(s, i);
      for (let u = f; u < f + a; u++)
        for (let d = p; d < p + l; d++) {
          if (n[u][d])
            throw new Error(
              `Unable to create occupancy grid for table, cell at ${u},${d} is already occupied`
            );
          n[u][d] = {
            row: s,
            col: i,
            rowspan: a,
            colspan: l,
            cell: c
          };
        }
    }
  return n;
}
function B(e) {
  const t = /* @__PURE__ */ new Set();
  return e.map((r) => ({
    cells: r.map((n) => t.has(n.row + ":" + n.col) ? !1 : (t.add(n.row + ":" + n.col), n.cell)).filter((n) => n !== !1)
  }));
}
function N(e, t, r = _(t)) {
  for (let n = 0; n < r.length; n++)
    for (let o = 0; o < r[n].length; o++) {
      const s = r[n][o];
      if (s.row === e.row && s.col === e.col)
        return { row: n, col: o, cell: s.cell };
    }
  throw new Error(
    `Unable to resolve relative table cell indices for table, cell at ${e.row},${e.col} is not occupied`
  );
}
function fe(e) {
  const t = e.content.rows.length;
  let r = 0;
  return e.content.rows.forEach((n) => {
    let o = 0;
    n.cells.forEach((s) => {
      o += I(s);
    }), r = Math.max(r, o);
  }), { height: t, width: r };
}
function pe(e, t, r = _(t)) {
  var o;
  const n = (o = r[e.row]) == null ? void 0 : o[e.col];
  if (n)
    return {
      row: n.row,
      col: n.col,
      cell: n.cell
    };
}
function Re(e, t) {
  var s;
  const r = _(e);
  if (t < 0 || t >= r.length)
    return [];
  let n = 0;
  for (let i = 0; i < t; i++) {
    const c = (s = r[n]) == null ? void 0 : s[0];
    if (!c)
      return [];
    n += c.rowspan;
  }
  const o = new Array(r[0].length).fill(!1).map((i, c) => pe(
    { row: n, col: c },
    e,
    r
  )).filter(
    (i) => i !== void 0
  );
  return o.filter((i, c) => o.findIndex((a) => a.row === i.row && a.col === i.col) === c);
}
function De(e, t) {
  var s;
  const r = _(e);
  if (t < 0 || t >= r[0].length)
    return [];
  let n = 0;
  for (let i = 0; i < t; i++) {
    const c = (s = r[0]) == null ? void 0 : s[n];
    if (!c)
      return [];
    n += c.colspan;
  }
  const o = new Array(r.length).fill(!1).map((i, c) => pe(
    { row: c, col: n },
    e,
    r
  )).filter(
    (i) => i !== void 0
  );
  return o.filter((i, c) => o.findIndex((a) => a.row === i.row && a.col === i.col) === c);
}
function nn(e, t, r, n = _(e)) {
  const { col: o } = N(
    {
      row: 0,
      col: t
    },
    e,
    n
  ), { col: s } = N(
    {
      row: 0,
      col: r
    },
    e,
    n
  );
  return n.forEach((i) => {
    const [c] = i.splice(o, 1);
    i.splice(s, 0, c);
  }), B(n);
}
function rn(e, t, r, n = _(e)) {
  const { row: o } = N(
    {
      row: t,
      col: 0
    },
    e,
    n
  ), { row: s } = N(
    {
      row: r,
      col: 0
    },
    e,
    n
  ), [i] = n.splice(o, 1);
  return n.splice(s, 0, i), B(n);
}
function J(e) {
  return e ? W(e) ? J(e.content) : typeof e == "string" ? e.length === 0 : Array.isArray(e) ? e.every(
    (t) => typeof t == "string" ? t.length === 0 : x(t) ? t.text.length === 0 : je(t) ? typeof t.content == "string" ? t.content.length === 0 : t.content.every((r) => r.text.length === 0) : !1
  ) : !1 : !0;
}
function on(e, t, r = _(e)) {
  if (t === "columns") {
    let s = 0;
    for (let i = r[0].length - 1; i >= 0 && r.every(
      (a) => J(a[i].cell) && a[i].colspan === 1
    ); i--)
      s++;
    for (let i = r.length - 1; i >= 0; i--) {
      const c = Math.max(
        r[i].length - s,
        1
      );
      r[i] = r[i].slice(0, c);
    }
    return B(r);
  }
  let n = 0;
  for (let s = r.length - 1; s >= 0 && r[s].every(
    (c) => J(c.cell) && c.rowspan === 1
  ); s--)
    n++;
  const o = Math.min(n, r.length - 1);
  return r.splice(r.length - o, o), B(r);
}
function sn(e, t, r, n = _(e)) {
  const { width: o, height: s } = fe(e);
  if (t === "columns")
    n.forEach((i, c) => {
      if (r >= 0)
        for (let a = 0; a < r; a++)
          i.push({
            row: c,
            col: Math.max(...i.map((l) => l.col)) + 1,
            rowspan: 1,
            colspan: 1,
            cell: U("")
          });
      else
        i.splice(o + r, -1 * r);
    });
  else if (r > 0)
    for (let i = 0; i < r; i++) {
      const c = new Array(o).fill(null).map((a, l) => ({
        row: s + i,
        col: l,
        rowspan: 1,
        colspan: 1,
        cell: U("")
      }));
      n.push(c);
    }
  else r < 0 && n.splice(s + r, -1 * r);
  return B(n);
}
function cn(e, t, r) {
  const n = Re(e, r);
  if (!n.some((a) => F(a.cell) > 1))
    return !0;
  let s = r, i = r;
  return n.forEach((a) => {
    const l = F(a.cell);
    s = Math.max(s, a.row + l - 1), i = Math.min(i, a.row);
  }), t < r ? r === s : r === i;
}
function an(e, t, r) {
  const n = De(e, r);
  if (!n.some((a) => I(a.cell) > 1))
    return !0;
  let s = r, i = r;
  return n.forEach((a) => {
    const l = I(a.cell);
    s = Math.max(s, a.col + l - 1), i = Math.min(i, a.col);
  }), t < r ? r === s : r === i;
}
function ln(e, t, r) {
  const n = N(e, r), o = N(t, r);
  return n.col === o.col;
}
function $e(e) {
  return "doc" in e ? e.doc.type.schema : e.type.schema;
}
function de(e) {
  return e.cached.blockNoteEditor;
}
function q(e) {
  return de(e).schema;
}
function V(e) {
  return q(e).blockSchema;
}
function Z(e) {
  return q(e).inlineContentSchema;
}
function P(e) {
  return q(e).styleSchema;
}
function K(e) {
  return de(e).blockCache;
}
function ae(e, t, r, n) {
  const o = [];
  for (const [i, c] of Object.entries(e.styles || {})) {
    const a = r[i];
    if (!a)
      throw new Error(`style ${i} not found in styleSchema`);
    if (a.propSchema === "boolean")
      c && o.push(t.mark(i));
    else if (a.propSchema === "string")
      c && o.push(t.mark(i, { stringValue: c }));
    else
      throw new R(a.propSchema);
  }
  return !n || !t.nodes[n].spec.code ? e.text.split(/(\n)/g).filter((i) => i.length > 0).map((i) => i === `
` ? t.nodes.hardBreak.createChecked() : t.text(i, o)) : e.text.length > 0 ? [t.text(e.text, o)] : [];
}
function Me(e, t, r) {
  const n = t.marks.link.create({
    href: e.href
  });
  return H(e.content, t, r).map(
    (o) => {
      if (o.type.name === "text")
        return o.mark([...o.marks, n]);
      if (o.type.name === "hardBreak")
        return o;
      throw new Error("unexpected node type");
    }
  );
}
function H(e, t, r, n) {
  const o = [];
  if (typeof e == "string")
    return o.push(
      ...ae(
        { text: e, styles: {} },
        t,
        r,
        n
      )
    ), o;
  for (const s of e)
    o.push(
      ...ae(s, t, r, n)
    );
  return o;
}
function j(e, t, r, n = P(t)) {
  const o = [];
  for (const s of e)
    typeof s == "string" ? o.push(
      ...H(s, t, n, r)
    ) : M(s) ? o.push(...Me(s, t, n)) : x(s) ? o.push(
      ...H([s], t, n, r)
    ) : o.push(
      he(s, t, n)
    );
  return o;
}
function Ue(e, t, r = P(t)) {
  const n = [], o = new Array(e.headerRows ?? 0).fill(!0), s = new Array(e.headerCols ?? 0).fill(!0), i = e.columnWidths ?? [];
  for (let c = 0; c < e.rows.length; c++) {
    const a = e.rows[c], l = [], f = o[c];
    for (let u = 0; u < a.cells.length; u++) {
      const d = a.cells[u], h = s[u], g = void 0;
      let y = null;
      const w = N(
        {
          row: c,
          col: u
        },
        { content: e }
      );
      let b = i[w.col] ? [i[w.col]] : null;
      if (d) if (typeof d == "string")
        y = t.text(d);
      else if (z(d)) {
        d.content && (y = j(
          d.content,
          t,
          "tableParagraph",
          r
        ));
        const C = I(d);
        C > 1 && (b = new Array(C).fill(!1).map((E, oe) => i[w.col + oe] ?? void 0));
      } else
        y = j(
          d,
          t,
          "tableParagraph",
          r
        );
      const k = t.nodes[h || f ? "tableHeader" : "tableCell"].createChecked(
        {
          ...z(d) ? d.props : {},
          colwidth: b
        },
        t.nodes.tableParagraph.createChecked(g, y)
      );
      l.push(k);
    }
    const p = t.nodes.tableRow.createChecked({}, l);
    n.push(p);
  }
  return n;
}
function he(e, t, r) {
  const n = e.type;
  let o;
  if (!t.nodes[n])
    throw new Error(`node type ${n} not found in schema`);
  if (!e.content)
    o = t.nodes[n].createChecked(e.props);
  else if (typeof e.content == "string") {
    const s = j(
      [e.content],
      t,
      n,
      r
    );
    o = t.nodes[n].createChecked(e.props, s);
  } else if (Array.isArray(e.content)) {
    const s = j(
      e.content,
      t,
      n,
      r
    );
    o = t.nodes[n].createChecked(e.props, s);
  } else if (e.content.type === "tableContent") {
    const s = Ue(e.content, t, r);
    o = t.nodes[n].createChecked(e.props, s);
  } else
    throw new R(e.content.type);
  return o;
}
function Fe(e, t, r = P(t)) {
  const n = [];
  if (e.children)
    for (const s of e.children)
      n.push(Fe(s, t, r));
  if (!e.type || // can happen if block.type is not defined (this should create the default node)
  t.nodes[e.type].isInGroup("blockContent")) {
    const s = he(
      e,
      t,
      r
    ), i = n.length > 0 ? t.nodes.blockGroup.createChecked({}, n) : void 0;
    return t.nodes.blockContainer.createChecked(
      {
        id: e.id,
        ...e.props
      },
      i ? [s, i] : s
    );
  } else {
    if (t.nodes[e.type].isInGroup("bnBlock"))
      return t.nodes[e.type].createChecked(
        {
          id: e.id,
          ...e.props
        },
        n
      );
    throw new Error(
      `block type ${e.type} doesn't match blockContent or bnBlock group`
    );
  }
}
const un = Object.freeze({
  status: "aborted"
});
function ye(e, t, r) {
  function n(c, a) {
    var l;
    Object.defineProperty(c, "_zod", {
      value: c._zod ?? {},
      enumerable: !1
    }), (l = c._zod).traits ?? (l.traits = /* @__PURE__ */ new Set()), c._zod.traits.add(e), t(c, a);
    for (const f in i.prototype)
      f in c || Object.defineProperty(c, f, { value: i.prototype[f].bind(c) });
    c._zod.constr = i, c._zod.def = a;
  }
  const o = (r == null ? void 0 : r.Parent) ?? Object;
  class s extends o {
  }
  Object.defineProperty(s, "name", { value: e });
  function i(c) {
    var a;
    const l = r != null && r.Parent ? new s() : this;
    n(l, c), (a = l._zod).deferred ?? (a.deferred = []);
    for (const f of l._zod.deferred)
      f();
    return l;
  }
  return Object.defineProperty(i, "init", { value: n }), Object.defineProperty(i, Symbol.hasInstance, {
    value: (c) => {
      var a, l;
      return r != null && r.Parent && c instanceof r.Parent ? !0 : (l = (a = c == null ? void 0 : c._zod) == null ? void 0 : a.traits) == null ? void 0 : l.has(e);
    }
  }), Object.defineProperty(i, "name", { value: e }), i;
}
const fn = Symbol("zod_brand");
class ge extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class pn extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
const le = {};
function D(e) {
  return e && Object.assign(le, e), le;
}
function Je(e) {
  return e;
}
function He(e) {
  return e;
}
function Le(e) {
}
function We(e) {
  throw new Error();
}
function qe(e) {
}
function Ve(e) {
  const t = Object.values(e).filter((n) => typeof n == "number");
  return Object.entries(e).filter(([n, o]) => t.indexOf(+n) === -1).map(([n, o]) => o);
}
function Ze(e, t = "|") {
  return e.map((r) => me(r)).join(t);
}
function we(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function be(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function Ke(e) {
  return e == null;
}
function Ge(e) {
  const t = e.startsWith("^") ? 1 : 0, r = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, r);
}
function Xe(e, t) {
  const r = (e.toString().split(".")[1] || "").length, n = t.toString();
  let o = (n.split(".")[1] || "").length;
  if (o === 0 && /\d?e-\d?/.test(n)) {
    const a = n.match(/\d?e-(\d?)/);
    a != null && a[1] && (o = Number.parseInt(a[1]));
  }
  const s = r > o ? r : o, i = Number.parseInt(e.toFixed(s).replace(".", "")), c = Number.parseInt(t.toFixed(s).replace(".", ""));
  return i % c / 10 ** s;
}
const ue = Symbol("evaluating");
function Qe(e, t, r) {
  let n;
  Object.defineProperty(e, t, {
    get() {
      if (n !== ue)
        return n === void 0 && (n = ue, n = r()), n;
    },
    set(o) {
      Object.defineProperty(e, t, {
        value: o
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function Ye(e) {
  return Object.create(Object.getPrototypeOf(e), Object.getOwnPropertyDescriptors(e));
}
function A(e, t, r) {
  Object.defineProperty(e, t, {
    value: r,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function O(...e) {
  const t = {};
  for (const r of e) {
    const n = Object.getOwnPropertyDescriptors(r);
    Object.assign(t, n);
  }
  return Object.defineProperties({}, t);
}
function et(e) {
  return O(e._zod.def);
}
function tt(e, t) {
  return t ? t.reduce((r, n) => r == null ? void 0 : r[n], e) : e;
}
function nt(e) {
  const t = Object.keys(e), r = t.map((n) => e[n]);
  return Promise.all(r).then((n) => {
    const o = {};
    for (let s = 0; s < t.length; s++)
      o[t[s]] = n[s];
    return o;
  });
}
function rt(e = 10) {
  const t = "abcdefghijklmnopqrstuvwxyz";
  let r = "";
  for (let n = 0; n < e; n++)
    r += t[Math.floor(Math.random() * t.length)];
  return r;
}
function ot(e) {
  return JSON.stringify(e);
}
const G = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function L(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const st = be(() => {
  var e;
  if (typeof navigator < "u" && ((e = navigator == null ? void 0 : navigator.userAgent) != null && e.includes("Cloudflare")))
    return !1;
  try {
    const t = Function;
    return new t(""), !0;
  } catch {
    return !1;
  }
});
function $(e) {
  if (L(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const r = t.prototype;
  return !(L(r) === !1 || Object.prototype.hasOwnProperty.call(r, "isPrototypeOf") === !1);
}
function it(e) {
  return $(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
function ct(e) {
  let t = 0;
  for (const r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t++;
  return t;
}
const at = (e) => {
  const t = typeof e;
  switch (t) {
    case "undefined":
      return "undefined";
    case "string":
      return "string";
    case "number":
      return Number.isNaN(e) ? "nan" : "number";
    case "boolean":
      return "boolean";
    case "function":
      return "function";
    case "bigint":
      return "bigint";
    case "symbol":
      return "symbol";
    case "object":
      return Array.isArray(e) ? "array" : e === null ? "null" : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? "promise" : typeof Map < "u" && e instanceof Map ? "map" : typeof Set < "u" && e instanceof Set ? "set" : typeof Date < "u" && e instanceof Date ? "date" : typeof File < "u" && e instanceof File ? "file" : "object";
    default:
      throw new Error(`Unknown data type: ${t}`);
  }
}, lt = /* @__PURE__ */ new Set(["string", "number", "symbol"]), ut = /* @__PURE__ */ new Set(["string", "number", "bigint", "boolean", "symbol", "undefined"]);
function ft(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function v(e, t, r) {
  const n = new e._zod.constr(t ?? e._zod.def);
  return (!t || r != null && r.parent) && (n._zod.parent = e), n;
}
function pt(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if ((t == null ? void 0 : t.message) !== void 0) {
    if ((t == null ? void 0 : t.error) !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function dt(e) {
  let t;
  return new Proxy({}, {
    get(r, n, o) {
      return t ?? (t = e()), Reflect.get(t, n, o);
    },
    set(r, n, o, s) {
      return t ?? (t = e()), Reflect.set(t, n, o, s);
    },
    has(r, n) {
      return t ?? (t = e()), Reflect.has(t, n);
    },
    deleteProperty(r, n) {
      return t ?? (t = e()), Reflect.deleteProperty(t, n);
    },
    ownKeys(r) {
      return t ?? (t = e()), Reflect.ownKeys(t);
    },
    getOwnPropertyDescriptor(r, n) {
      return t ?? (t = e()), Reflect.getOwnPropertyDescriptor(t, n);
    },
    defineProperty(r, n, o) {
      return t ?? (t = e()), Reflect.defineProperty(t, n, o);
    }
  });
}
function me(e) {
  return typeof e == "bigint" ? e.toString() + "n" : typeof e == "string" ? `"${e}"` : `${e}`;
}
function ht(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
const yt = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
}, gt = {
  int64: [/* @__PURE__ */ BigInt("-9223372036854775808"), /* @__PURE__ */ BigInt("9223372036854775807")],
  uint64: [/* @__PURE__ */ BigInt(0), /* @__PURE__ */ BigInt("18446744073709551615")]
};
function wt(e, t) {
  const r = e._zod.def, n = O(e._zod.def, {
    get shape() {
      const o = {};
      for (const s in t) {
        if (!(s in r.shape))
          throw new Error(`Unrecognized key: "${s}"`);
        t[s] && (o[s] = r.shape[s]);
      }
      return A(this, "shape", o), o;
    },
    checks: []
  });
  return v(e, n);
}
function bt(e, t) {
  const r = e._zod.def, n = O(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape };
      for (const s in t) {
        if (!(s in r.shape))
          throw new Error(`Unrecognized key: "${s}"`);
        t[s] && delete o[s];
      }
      return A(this, "shape", o), o;
    },
    checks: []
  });
  return v(e, n);
}
function mt(e, t) {
  if (!$(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const r = e._zod.def.checks;
  if (r && r.length > 0)
    throw new Error("Object schemas containing refinements cannot be extended. Use `.safeExtend()` instead.");
  const o = O(e._zod.def, {
    get shape() {
      const s = { ...e._zod.def.shape, ...t };
      return A(this, "shape", s), s;
    },
    checks: []
  });
  return v(e, o);
}
function kt(e, t) {
  if (!$(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const r = {
    ...e._zod.def,
    get shape() {
      const n = { ...e._zod.def.shape, ...t };
      return A(this, "shape", n), n;
    },
    checks: e._zod.def.checks
  };
  return v(e, r);
}
function Et(e, t) {
  const r = O(e._zod.def, {
    get shape() {
      const n = { ...e._zod.def.shape, ...t._zod.def.shape };
      return A(this, "shape", n), n;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return v(e, r);
}
function Ct(e, t, r) {
  const n = O(t._zod.def, {
    get shape() {
      const o = t._zod.def.shape, s = { ...o };
      if (r)
        for (const i in r) {
          if (!(i in o))
            throw new Error(`Unrecognized key: "${i}"`);
          r[i] && (s[i] = e ? new e({
            type: "optional",
            innerType: o[i]
          }) : o[i]);
        }
      else
        for (const i in o)
          s[i] = e ? new e({
            type: "optional",
            innerType: o[i]
          }) : o[i];
      return A(this, "shape", s), s;
    },
    checks: []
  });
  return v(t, n);
}
function _t(e, t, r) {
  const n = O(t._zod.def, {
    get shape() {
      const o = t._zod.def.shape, s = { ...o };
      if (r)
        for (const i in r) {
          if (!(i in s))
            throw new Error(`Unrecognized key: "${i}"`);
          r[i] && (s[i] = new e({
            type: "nonoptional",
            innerType: o[i]
          }));
        }
      else
        for (const i in o)
          s[i] = new e({
            type: "nonoptional",
            innerType: o[i]
          });
      return A(this, "shape", s), s;
    },
    checks: []
  });
  return v(t, n);
}
function At(e, t = 0) {
  var r;
  if (e.aborted === !0)
    return !0;
  for (let n = t; n < e.issues.length; n++)
    if (((r = e.issues[n]) == null ? void 0 : r.continue) !== !0)
      return !0;
  return !1;
}
function Ot(e, t) {
  return t.map((r) => {
    var n;
    return (n = r).path ?? (n.path = []), r.path.unshift(e), r;
  });
}
function S(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.message;
}
function T(e, t, r) {
  var o, s, i, c, a, l;
  const n = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const f = S((i = (s = (o = e.inst) == null ? void 0 : o._zod.def) == null ? void 0 : s.error) == null ? void 0 : i.call(s, e)) ?? S((c = t == null ? void 0 : t.error) == null ? void 0 : c.call(t, e)) ?? S((a = r.customError) == null ? void 0 : a.call(r, e)) ?? S((l = r.localeError) == null ? void 0 : l.call(r, e)) ?? "Invalid input";
    n.message = f;
  }
  return delete n.inst, delete n.continue, t != null && t.reportInput || delete n.input, n;
}
function vt(e) {
  return e instanceof Set ? "set" : e instanceof Map ? "map" : e instanceof File ? "file" : "unknown";
}
function Nt(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function xt(...e) {
  const [t, r, n] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: r,
    inst: n
  } : { ...t };
}
function Pt(e) {
  return Object.entries(e).filter(([t, r]) => Number.isNaN(Number.parseInt(t, 10))).map((t) => t[1]);
}
function ke(e) {
  const t = atob(e), r = new Uint8Array(t.length);
  for (let n = 0; n < t.length; n++)
    r[n] = t.charCodeAt(n);
  return r;
}
function Ee(e) {
  let t = "";
  for (let r = 0; r < e.length; r++)
    t += String.fromCharCode(e[r]);
  return btoa(t);
}
function St(e) {
  const t = e.replace(/-/g, "+").replace(/_/g, "/"), r = "=".repeat((4 - t.length % 4) % 4);
  return ke(t + r);
}
function It(e) {
  return Ee(e).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function Bt(e) {
  const t = e.replace(/^0x/, "");
  if (t.length % 2 !== 0)
    throw new Error("Invalid hex string length");
  const r = new Uint8Array(t.length / 2);
  for (let n = 0; n < t.length; n += 2)
    r[n / 2] = Number.parseInt(t.slice(n, n + 2), 16);
  return r;
}
function Tt(e) {
  return Array.from(e).map((t) => t.toString(16).padStart(2, "0")).join("");
}
class zt {
  constructor(...t) {
  }
}
const dn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BIGINT_FORMAT_RANGES: gt,
  Class: zt,
  NUMBER_FORMAT_RANGES: yt,
  aborted: At,
  allowsEval: st,
  assert: qe,
  assertEqual: Je,
  assertIs: Le,
  assertNever: We,
  assertNotEqual: He,
  assignProp: A,
  base64ToUint8Array: ke,
  base64urlToUint8Array: St,
  cached: be,
  captureStackTrace: G,
  cleanEnum: Pt,
  cleanRegex: Ge,
  clone: v,
  cloneDef: et,
  createTransparentProxy: dt,
  defineLazy: Qe,
  esc: ot,
  escapeRegex: ft,
  extend: mt,
  finalizeIssue: T,
  floatSafeRemainder: Xe,
  getElementAtPath: tt,
  getEnumValues: Ve,
  getLengthableOrigin: Nt,
  getParsedType: at,
  getSizableOrigin: vt,
  hexToUint8Array: Bt,
  isObject: L,
  isPlainObject: $,
  issue: xt,
  joinValues: Ze,
  jsonStringifyReplacer: we,
  merge: Et,
  mergeDefs: O,
  normalizeParams: pt,
  nullish: Ke,
  numKeys: ct,
  objectClone: Ye,
  omit: bt,
  optionalKeys: ht,
  partial: Ct,
  pick: wt,
  prefixIssues: Ot,
  primitiveTypes: ut,
  promiseAllObject: nt,
  propertyKeyTypes: lt,
  randomString: rt,
  required: _t,
  safeExtend: kt,
  shallowClone: it,
  stringifyPrimitive: me,
  uint8ArrayToBase64: Ee,
  uint8ArrayToBase64url: It,
  uint8ArrayToHex: Tt,
  unwrapMessage: S
}, Symbol.toStringTag, { value: "Module" })), Ce = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, we, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, jt = ye("$ZodError", Ce), m = ye("$ZodError", Ce, { Parent: Error });
function hn(e, t = (r) => r.message) {
  const r = {}, n = [];
  for (const o of e.issues)
    o.path.length > 0 ? (r[o.path[0]] = r[o.path[0]] || [], r[o.path[0]].push(t(o))) : n.push(t(o));
  return { formErrors: n, fieldErrors: r };
}
function yn(e, t = (r) => r.message) {
  const r = { _errors: [] }, n = (o) => {
    for (const s of o.issues)
      if (s.code === "invalid_union" && s.errors.length)
        s.errors.map((i) => n({ issues: i }));
      else if (s.code === "invalid_key")
        n({ issues: s.issues });
      else if (s.code === "invalid_element")
        n({ issues: s.issues });
      else if (s.path.length === 0)
        r._errors.push(t(s));
      else {
        let i = r, c = 0;
        for (; c < s.path.length; ) {
          const a = s.path[c];
          c === s.path.length - 1 ? (i[a] = i[a] || { _errors: [] }, i[a]._errors.push(t(s))) : i[a] = i[a] || { _errors: [] }, i = i[a], c++;
        }
      }
  };
  return n(e), r;
}
function gn(e, t = (r) => r.message) {
  const r = { errors: [] }, n = (o, s = []) => {
    var i, c;
    for (const a of o.issues)
      if (a.code === "invalid_union" && a.errors.length)
        a.errors.map((l) => n({ issues: l }, a.path));
      else if (a.code === "invalid_key")
        n({ issues: a.issues }, a.path);
      else if (a.code === "invalid_element")
        n({ issues: a.issues }, a.path);
      else {
        const l = [...s, ...a.path];
        if (l.length === 0) {
          r.errors.push(t(a));
          continue;
        }
        let f = r, p = 0;
        for (; p < l.length; ) {
          const u = l[p], d = p === l.length - 1;
          typeof u == "string" ? (f.properties ?? (f.properties = {}), (i = f.properties)[u] ?? (i[u] = { errors: [] }), f = f.properties[u]) : (f.items ?? (f.items = []), (c = f.items)[u] ?? (c[u] = { errors: [] }), f = f.items[u]), d && f.errors.push(t(a)), p++;
        }
      }
  };
  return n(e), r;
}
function Rt(e) {
  const t = [], r = e.map((n) => typeof n == "object" ? n.key : n);
  for (const n of r)
    typeof n == "number" ? t.push(`[${n}]`) : typeof n == "symbol" ? t.push(`[${JSON.stringify(String(n))}]`) : /[^\w$]/.test(n) ? t.push(`[${JSON.stringify(n)}]`) : (t.length && t.push("."), t.push(n));
  return t.join("");
}
function wn(e) {
  var n;
  const t = [], r = [...e.issues].sort((o, s) => (o.path ?? []).length - (s.path ?? []).length);
  for (const o of r)
    t.push(`✖ ${o.message}`), (n = o.path) != null && n.length && t.push(`  → at ${Rt(o.path)}`);
  return t.join(`
`);
}
const X = (e) => (t, r, n, o) => {
  const s = n ? Object.assign(n, { async: !1 }) : { async: !1 }, i = t._zod.run({ value: r, issues: [] }, s);
  if (i instanceof Promise)
    throw new ge();
  if (i.issues.length) {
    const c = new ((o == null ? void 0 : o.Err) ?? e)(i.issues.map((a) => T(a, s, D())));
    throw G(c, o == null ? void 0 : o.callee), c;
  }
  return i.value;
}, _e = /* @__PURE__ */ X(m), Q = (e) => async (t, r, n, o) => {
  const s = n ? Object.assign(n, { async: !0 }) : { async: !0 };
  let i = t._zod.run({ value: r, issues: [] }, s);
  if (i instanceof Promise && (i = await i), i.issues.length) {
    const c = new ((o == null ? void 0 : o.Err) ?? e)(i.issues.map((a) => T(a, s, D())));
    throw G(c, o == null ? void 0 : o.callee), c;
  }
  return i.value;
}, bn = /* @__PURE__ */ Q(m), Y = (e) => (t, r, n) => {
  const o = n ? { ...n, async: !1 } : { async: !1 }, s = t._zod.run({ value: r, issues: [] }, o);
  if (s instanceof Promise)
    throw new ge();
  return s.issues.length ? {
    success: !1,
    error: new (e ?? jt)(s.issues.map((i) => T(i, o, D())))
  } : { success: !0, data: s.value };
}, mn = /* @__PURE__ */ Y(m), ee = (e) => async (t, r, n) => {
  const o = n ? Object.assign(n, { async: !0 }) : { async: !0 };
  let s = t._zod.run({ value: r, issues: [] }, o);
  return s instanceof Promise && (s = await s), s.issues.length ? {
    success: !1,
    error: new e(s.issues.map((i) => T(i, o, D())))
  } : { success: !0, data: s.value };
}, kn = /* @__PURE__ */ ee(m), Dt = (e) => (t, r, n) => {
  const o = n ? Object.assign(n, { direction: "backward" }) : { direction: "backward" };
  return X(e)(t, r, o);
}, En = /* @__PURE__ */ Dt(m), $t = (e) => (t, r, n) => X(e)(t, r, n), Cn = /* @__PURE__ */ $t(m), Mt = (e) => async (t, r, n) => {
  const o = n ? Object.assign(n, { direction: "backward" }) : { direction: "backward" };
  return Q(e)(t, r, o);
}, _n = /* @__PURE__ */ Mt(m), Ut = (e) => async (t, r, n) => Q(e)(t, r, n), An = /* @__PURE__ */ Ut(m), Ft = (e) => (t, r, n) => {
  const o = n ? Object.assign(n, { direction: "backward" }) : { direction: "backward" };
  return Y(e)(t, r, o);
}, On = /* @__PURE__ */ Ft(m), Jt = (e) => (t, r, n) => Y(e)(t, r, n), vn = /* @__PURE__ */ Jt(m), Ht = (e) => async (t, r, n) => {
  const o = n ? Object.assign(n, { direction: "backward" }) : { direction: "backward" };
  return ee(e)(t, r, o);
}, Nn = /* @__PURE__ */ Ht(m), Lt = (e) => async (t, r, n) => ee(e)(t, r, n), xn = /* @__PURE__ */ Lt(m);
function Wt(e, t = JSON.stringify) {
  const r = {};
  return e.filter((n) => {
    const o = t(n);
    return Object.prototype.hasOwnProperty.call(r, o) ? !1 : r[o] = !0;
  });
}
function qt(e) {
  const t = e.filter(
    (n, o) => e.indexOf(n) !== o
  );
  return Wt(t);
}
const Vt = ve.create({
  name: "uniqueID",
  // we’ll set a very high priority to make sure this runs first
  // and is compatible with `appendTransaction` hooks of other extensions
  priority: 1e4,
  addOptions() {
    return {
      attributeName: "id",
      types: [],
      setIdAttribute: !1,
      generateID: () => {
        if (typeof window < "u" && window.__TEST_OPTIONS) {
          const e = window.__TEST_OPTIONS;
          return e.mockID === void 0 ? e.mockID = 0 : e.mockID++, e.mockID.toString();
        }
        return ze();
      },
      filterTransaction: null
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          [this.options.attributeName]: {
            default: null,
            parseHTML: (e) => e.getAttribute(`data-${this.options.attributeName}`),
            renderHTML: (e) => {
              const t = {
                [`data-${this.options.attributeName}`]: e[this.options.attributeName]
              };
              return this.options.setIdAttribute ? {
                ...t,
                id: e[this.options.attributeName]
              } : t;
            }
          }
        }
      }
    ];
  },
  // check initial content for missing ids
  // onCreate() {
  //   // Don’t do this when the collaboration extension is active
  //   // because this may update the content, so Y.js tries to merge these changes.
  //   // This leads to empty block nodes.
  //   // See: https://github.com/ueberdosis/tiptap/issues/2400
  //   if (
  //     this.editor.extensionManager.extensions.find(
  //       (extension) => extension.name === "collaboration"
  //     )
  //   ) {
  //     return;
  //   }
  //   const { view, state } = this.editor;
  //   const { tr, doc } = state;
  //   const { types, attributeName, generateID } = this.options;
  //   const nodesWithoutId = findChildren(doc, (node) => {
  //     return (
  //       types.includes(node.type.name) && node.attrs[attributeName] === null
  //     );
  //   });
  //   nodesWithoutId.forEach(({ node, pos }) => {
  //     tr.setNodeMarkup(pos, undefined, {
  //       ...node.attrs,
  //       [attributeName]: generateID(),
  //     });
  //   });
  //   tr.setMeta("addToHistory", false);
  //   view.dispatch(tr);
  // },
  addProseMirrorPlugins() {
    let e = null, t = !1;
    return [
      new Be({
        key: new Te("uniqueID"),
        appendTransaction: (r, n, o) => {
          const s = r.some((h) => h.docChanged) && !n.doc.eq(o.doc), i = this.options.filterTransaction && r.some((h) => {
            var g, y;
            return !((y = (g = this.options).filterTransaction) != null && y.call(g, h));
          });
          if (!s || i)
            return;
          const { tr: c } = o, { types: a, attributeName: l, generateID: f } = this.options, p = Ne(
            n.doc,
            r
          ), { mapping: u } = p;
          if (xe(p).forEach(({ newRange: h }) => {
            const g = Pe(
              o.doc,
              h,
              (b) => a.includes(b.type.name)
            ), y = g.map(({ node: b }) => b.attrs[l]).filter((b) => b !== null), w = qt(y);
            g.forEach(({ node: b, pos: k }) => {
              var se;
              const C = (se = c.doc.nodeAt(k)) == null ? void 0 : se.attrs[l];
              if (C === null) {
                const ie = n.doc.type.createAndFill().content;
                if (n.doc.content.findDiffStart(ie) === null) {
                  const ce = JSON.parse(
                    JSON.stringify(o.doc.toJSON())
                  );
                  if (ce.content[0].content[0].attrs.id = "initialBlockId", JSON.stringify(ce.content) === JSON.stringify(ie.toJSON())) {
                    c.setNodeMarkup(k, void 0, {
                      ...b.attrs,
                      [l]: "initialBlockId"
                    });
                    return;
                  }
                }
                c.setNodeMarkup(k, void 0, {
                  ...b.attrs,
                  [l]: f()
                });
                return;
              }
              const { deleted: E } = u.invert().mapResult(k);
              E && w.includes(C) && c.setNodeMarkup(k, void 0, {
                ...b.attrs,
                [l]: f()
              });
            });
          }), !!c.steps.length)
            return c.setMeta("uniqueID", !0), c;
        },
        // we register a global drag handler to track the current drag source element
        view(r) {
          const n = (o) => {
            let s;
            e = !((s = r.dom.parentElement) === null || s === void 0) && s.contains(o.target) ? r.dom.parentElement : null;
          };
          return window.addEventListener("dragstart", n), {
            destroy() {
              window.removeEventListener("dragstart", n);
            }
          };
        },
        props: {
          // `handleDOMEvents` is called before `transformPasted` so we can do
          // some checks before. However, `transformPasted` only runs when
          // editor content is pasted - not external content.
          handleDOMEvents: {
            // only create new ids for dropped content while holding `alt`
            // or content is dragged from another editor
            drop: (r, n) => {
              let o;
              return e !== r.dom.parentElement || ((o = n.dataTransfer) === null || o === void 0 ? void 0 : o.effectAllowed) === "copy" ? t = !0 : t = !1, e = null, !1;
            },
            // always create new ids on pasted content
            paste: () => (t = !0, !1)
          },
          // we’ll remove ids for every pasted node
          // so we can create a new one within `appendTransaction`
          transformPasted: (r) => {
            if (!t)
              return r;
            const { types: n, attributeName: o } = this.options, s = (i) => {
              const c = [];
              return i.forEach((a) => {
                if (a.isText) {
                  c.push(a);
                  return;
                }
                if (!n.includes(a.type.name)) {
                  c.push(a.copy(s(a.content)));
                  return;
                }
                const l = a.type.create(
                  {
                    ...a.attrs,
                    [o]: null
                  },
                  s(a.content),
                  a.marks
                );
                c.push(l);
              }), Ie.from(c);
            };
            return t = !1, new Se(
              s(r.content),
              r.openStart,
              r.openEnd
            );
          }
        }
      })
    ];
  }
});
function Ae(e, t) {
  const r = e.resolve(t);
  if (r.nodeAfter && r.nodeAfter.type.isInGroup("bnBlock"))
    return {
      posBeforeNode: r.pos,
      node: r.nodeAfter
    };
  let n = r.depth, o = r.node(n);
  for (; n > 0; ) {
    if (o.type.isInGroup("bnBlock"))
      return {
        posBeforeNode: r.before(n),
        node: o
      };
    n--, o = r.node(n);
  }
  const s = [];
  e.descendants((c, a) => {
    c.type.isInGroup("bnBlock") && s.push(a);
  }), console.warn(`Position ${t} is not within a blockContainer node.`);
  const i = e.resolve(
    s.find((c) => c >= t) || s[s.length - 1]
  );
  return {
    posBeforeNode: i.pos,
    node: i.nodeAfter
  };
}
function te(e, t) {
  if (!e.type.isInGroup("bnBlock"))
    throw new Error(
      `Attempted to get bnBlock node at position but found node of different type ${e.type.name}`
    );
  const r = e, n = t, o = n + r.nodeSize, s = {
    node: r,
    beforePos: n,
    afterPos: o
  };
  if (r.type.name === "blockContainer") {
    let i, c;
    if (r.forEach((a, l) => {
      if (a.type.spec.group === "blockContent") {
        const f = a, p = n + l + 1, u = p + a.nodeSize;
        i = {
          node: f,
          beforePos: p,
          afterPos: u
        };
      } else if (a.type.name === "blockGroup") {
        const f = a, p = n + l + 1, u = p + a.nodeSize;
        c = {
          node: f,
          beforePos: p,
          afterPos: u
        };
      }
    }), !i)
      throw new Error(
        `blockContainer node does not contain a blockContent node in its children: ${r}`
      );
    return {
      isBlockContainer: !0,
      bnBlock: s,
      blockContent: i,
      childContainer: c,
      blockNoteType: i.node.type.name
    };
  } else {
    if (!s.node.type.isInGroup("childContainer"))
      throw new Error(
        `bnBlock node is not in the childContainer group: ${s.node}`
      );
    return {
      isBlockContainer: !1,
      bnBlock: s,
      childContainer: s,
      blockNoteType: s.node.type.name
    };
  }
}
function Oe(e) {
  return te(e.node, e.posBeforeNode);
}
function Pn(e) {
  if (!e.nodeAfter)
    throw new Error(
      `Attempted to get blockContainer node at position ${e.pos} but a node at this position does not exist`
    );
  return te(e.nodeAfter, e.pos);
}
function Sn(e) {
  const t = Ae(e.doc, e.selection.anchor);
  return Oe(t);
}
function In(e) {
  const t = Ae(e.doc, e.selection.anchor);
  return Oe(t);
}
function Zt(e, t, r) {
  var s, i;
  const n = {
    type: "tableContent",
    columnWidths: [],
    headerRows: void 0,
    headerCols: void 0,
    rows: []
  }, o = [];
  e.content.forEach((c, a, l) => {
    const f = {
      cells: []
    };
    l === 0 && c.content.forEach((p) => {
      let u = p.attrs.colwidth;
      u == null && (u = new Array(p.attrs.colspan ?? 1).fill(void 0)), n.columnWidths.push(...u);
    }), f.cells = c.content.content.map((p, u) => (o[l] || (o[l] = []), o[l][u] = p.type.name === "tableHeader", {
      type: "tableCell",
      content: p.content.content.map(
        (h) => ne(h, t, r)
      ).reduce(
        (h, g) => {
          if (!h.length)
            return g;
          const y = h[h.length - 1], w = g[0];
          return w && x(y) && x(w) && JSON.stringify(y.styles) === JSON.stringify(w.styles) ? (y.text += `
` + w.text, h.push(...g.slice(1)), h) : (h.push(...g), h);
        },
        []
      ),
      props: {
        colspan: p.attrs.colspan,
        rowspan: p.attrs.rowspan,
        backgroundColor: p.attrs.backgroundColor,
        textColor: p.attrs.textColor,
        textAlignment: p.attrs.textAlignment
      }
    })), n.rows.push(f);
  });
  for (let c = 0; c < o.length; c++)
    (s = o[c]) != null && s.every((a) => a) && (n.headerRows = (n.headerRows ?? 0) + 1);
  for (let c = 0; c < ((i = o[0]) == null ? void 0 : i.length); c++)
    o != null && o.every((a) => a[c]) && (n.headerCols = (n.headerCols ?? 0) + 1);
  return n;
}
function ne(e, t, r) {
  const n = [];
  let o;
  return e.content.forEach((s) => {
    if (s.type.name === "hardBreak") {
      if (o)
        if (x(o))
          o.text += `
`;
        else if (M(o))
          o.content[o.content.length - 1].text += `
`;
        else
          throw new Error("unexpected");
      else
        o = {
          type: "text",
          text: `
`,
          styles: {}
        };
      return;
    }
    if (s.type.name !== "link" && s.type.name !== "text") {
      if (!t[s.type.name]) {
        console.warn("unrecognized inline content type", s.type.name);
        return;
      }
      o && (n.push(o), o = void 0), n.push(
        Kt(s, t, r)
      );
      return;
    }
    const i = {};
    let c;
    for (const a of s.marks)
      if (a.type.name === "link")
        c = a;
      else {
        const l = r[a.type.name];
        if (!l) {
          if (a.type.spec.blocknoteIgnore)
            continue;
          throw new Error(`style ${a.type.name} not found in styleSchema`);
        }
        if (l.propSchema === "boolean")
          i[l.type] = !0;
        else if (l.propSchema === "string")
          i[l.type] = a.attrs.stringValue;
        else
          throw new R(l.propSchema);
      }
    o ? x(o) ? c ? (n.push(o), o = {
      type: "link",
      href: c.attrs.href,
      content: [
        {
          type: "text",
          text: s.textContent,
          styles: i
        }
      ]
    }) : JSON.stringify(o.styles) === JSON.stringify(i) ? o.text += s.textContent : (n.push(o), o = {
      type: "text",
      text: s.textContent,
      styles: i
    }) : M(o) && (c ? o.href === c.attrs.href ? JSON.stringify(
      o.content[o.content.length - 1].styles
    ) === JSON.stringify(i) ? o.content[o.content.length - 1].text += s.textContent : o.content.push({
      type: "text",
      text: s.textContent,
      styles: i
    }) : (n.push(o), o = {
      type: "link",
      href: c.attrs.href,
      content: [
        {
          type: "text",
          text: s.textContent,
          styles: i
        }
      ]
    }) : (n.push(o), o = {
      type: "text",
      text: s.textContent,
      styles: i
    })) : c ? o = {
      type: "link",
      href: c.attrs.href,
      content: [
        {
          type: "text",
          text: s.textContent,
          styles: i
        }
      ]
    } : o = {
      type: "text",
      text: s.textContent,
      styles: i
    };
  }), o && n.push(o), n;
}
function Kt(e, t, r) {
  if (e.type.name === "text" || e.type.name === "link")
    throw new Error("unexpected");
  const n = t[e.type.name];
  if (!n)
    throw Error("ic node is of an unrecognized type: " + e.type.name);
  const o = _e(n.propSchema._zodSource, e.attrs);
  let s;
  return n.content === "styled" ? s = ne(
    e,
    t,
    r
  ) : s = void 0, {
    type: e.type.name,
    props: o,
    content: s
  };
}
function re(e, t, r = V(t), n = Z(t), o = P(t), s = K(t)) {
  var y;
  if (!e.type.isInGroup("bnBlock"))
    throw Error("Node should be a bnBlock, but is instead: " + e.type.name);
  const i = s == null ? void 0 : s.get(e);
  if (i)
    return i;
  const c = te(e, 0);
  let a = c.bnBlock.node.attrs.id;
  a === null && (a = Vt.options.generateID());
  const l = r[c.blockNoteType];
  if (!l)
    throw Error("Block is of an unrecognized type: " + c.blockNoteType);
  const f = {
    // technically we only need this for "width" on ColumnList nodes
    ...e.attrs,
    // the actual block props are stored on the blockContent node
    ...c.isBlockContainer ? c.blockContent.node.attrs : {}
  };
  delete f.id;
  const p = _e(l.propSchema._zodSource, f), u = r[c.blockNoteType], d = [];
  (y = c.childContainer) == null || y.node.forEach((w) => {
    d.push(
      re(
        w,
        t,
        r,
        n,
        o,
        s
      )
    );
  });
  let h;
  if (u.content === "inline") {
    if (!c.isBlockContainer)
      throw new Error("impossible");
    h = ne(
      c.blockContent.node,
      n,
      o
    );
  } else if (u.content === "table") {
    if (!c.isBlockContainer)
      throw new Error("impossible");
    h = Zt(
      c.blockContent.node,
      n,
      o
    );
  } else if (u.content === "none")
    h = void 0;
  else
    throw new R(u.content);
  const g = {
    id: a,
    type: u.type,
    props: p,
    content: h,
    children: d
  };
  return s == null || s.set(e, g), g;
}
function Bn(e, t = $e(e), r = V(t), n = Z(t), o = P(t), s = K(t)) {
  const i = [];
  return e.firstChild && e.firstChild.descendants((c) => (i.push(
    re(
      c,
      t,
      r,
      n,
      o,
      s
    )
  ), !1)), i;
}
function Tn(e, t, r = V(t), n = Z(t), o = P(t), s = K(t)) {
  function i(c, a, l) {
    if (c.type.name !== "blockGroup")
      throw new Error("unexpected");
    const f = [];
    let p, u;
    return c.forEach((d, h, g) => {
      if (d.type.name !== "blockContainer")
        throw new Error("unexpected");
      if (d.childCount === 0)
        return;
      if (d.childCount === 0 || d.childCount > 2)
        throw new Error(
          "unexpected, blockContainer.childCount: " + d.childCount
        );
      const y = g === 0, w = g === c.childCount - 1;
      if (d.firstChild.type.name === "blockGroup") {
        if (!y)
          throw new Error("unexpected");
        const E = i(
          d.firstChild,
          Math.max(0, a - 1),
          w ? Math.max(0, l - 1) : 0
        );
        p = E.blockCutAtStart, w && (u = E.blockCutAtEnd), f.push(...E.blocks);
        return;
      }
      const b = re(
        d,
        t,
        r,
        n,
        o,
        s
      ), k = d.childCount > 1 ? d.child(1) : void 0;
      let C = [];
      if (k) {
        const E = i(
          k,
          0,
          // TODO: can this be anything other than 0?
          w ? Math.max(0, l - 1) : 0
        );
        C = E.blocks, w && (u = E.blockCutAtEnd);
      }
      w && !k && l > 1 && (u = b.id), y && a > 1 && (p = b.id), f.push({
        ...b,
        children: C
      });
    }), { blocks: f, blockCutAtStart: p, blockCutAtEnd: u };
  }
  if (e.content.childCount === 0)
    return {
      blocks: [],
      blockCutAtStart: void 0,
      blockCutAtEnd: void 0
    };
  if (e.content.childCount !== 1)
    throw new Error(
      "slice must be a single block, did you forget includeParents=true?"
    );
  return i(
    e.content.firstChild,
    Math.max(e.openStart - 1, 0),
    Math.max(e.openEnd - 1, 0)
  );
}
export {
  ye as $,
  Oe as A,
  tn as B,
  te as C,
  V as D,
  Z as E,
  P as F,
  K as G,
  M as H,
  je as I,
  x as J,
  U as K,
  W as L,
  z as M,
  I as N,
  F as O,
  Xe as P,
  yt as Q,
  gt as R,
  Ke as S,
  vt as T,
  R as U,
  Nt as V,
  ft as W,
  Ot as X,
  ge as Y,
  mn as Z,
  kn as _,
  re as a,
  At as a0,
  Qe as a1,
  be as a2,
  L as a3,
  le as a4,
  st as a5,
  ot as a6,
  Ge as a7,
  $ as a8,
  T as a9,
  Ht as aA,
  Y as aB,
  ee as aC,
  v as aD,
  Cn as aE,
  An as aF,
  En as aG,
  _n as aH,
  hn as aI,
  yn as aJ,
  wn as aK,
  vn as aL,
  xn as aM,
  On as aN,
  Nn as aO,
  Rt as aP,
  gn as aQ,
  dn as aR,
  we as aS,
  O as aT,
  mt as aU,
  kt as aV,
  Et as aW,
  wt as aX,
  bt as aY,
  Ct as aZ,
  _t as a_,
  D as aa,
  lt as ab,
  Ve as ac,
  pn as ad,
  ut as ae,
  _e as af,
  bn as ag,
  xt as ah,
  ht as ai,
  Ze as aj,
  me as ak,
  pt as al,
  it as am,
  jt as an,
  m as ao,
  fn as ap,
  un as aq,
  $t as ar,
  Ut as as,
  Dt as at,
  Mt as au,
  X as av,
  Q as aw,
  Jt as ax,
  Lt as ay,
  Ft as az,
  Fe as b,
  cn as c,
  Bn as d,
  an as e,
  nn as f,
  $e as g,
  fe as h,
  j as i,
  sn as j,
  on as k,
  ln as l,
  rn as m,
  Kt as n,
  De as o,
  Re as p,
  Pn as q,
  In as r,
  Sn as s,
  Ue as t,
  q as u,
  Ae as v,
  Zt as w,
  ne as x,
  Vt as y,
  Tn as z
};
//# sourceMappingURL=nodeToBlock-DJYxfW65.js.map
